/**
 * <SoundModeBadge> — le mode que le tuteur a posé sur l'élève, en live (molecule).
 *
 * Le tuteur passe chaque élève d'un mode à l'autre (`soundModeIds`, voir
 * `docs/sound-mode-architecture.md`) :
 *  - **Dialogue** : l'élève entend le tuteur, son micro est ouvert. Aujourd'hui, rien ne le dit ;
 *    ici, la tinte de progression et le micro ;
 *  - **Concentré** : le silence, le micro coupé. Le violet du livre (`purple`, « surface LIVE
 *    uniquement »), plein, et le haut-parleur barré.
 *
 * La chip du livre (`<Badge>`), jamais une chip faite à la main. Le live de l'élève ne la pose plus
 * (Wajih, 19/10, au grand écran comme au téléphone) : le mode s'y lit dans la bulle tandem
 * (`<LiveTandemBubble>`) et au micro violet de la barre. Le type `UISoundMode` reste ici.
 */
import React from "react"

import { type UISoundMode } from "../../../ports/primary/ui/types/studentLive"
import { Badge } from "../../atoms/Badge"

// Le mode du son : sa forme vit dans `ports/primary/ui/types` (socle du live).
export type { UISoundMode }

export type SoundModeBadgeProps = {
    mode: UISoundMode
    testID?: string
}

/** Le nom de chaque mode, partout où le live le dit (la chip, la bascule du tuteur, son bandeau). */
export const SOUND_MODE_LABELS: Record<UISoundMode, string> = {
    dialogue: "Dialogue",
    focused: "Concentré",
}

export function SoundModeBadge(props: SoundModeBadgeProps) {
    const { mode, testID } = props

    if (mode === "focused") {
        return (
            <Badge
                text={SOUND_MODE_LABELS.focused}
                variant="purple"
                iconName="volume-mute"
                truncate={false}
                testID={testID}
            />
        )
    }
    return (
        <Badge
            text={SOUND_MODE_LABELS.dialogue}
            variant="success"
            tinted
            iconName="microphone"
            truncate={false}
            testID={testID}
        />
    )
}
